// extracted by mini-css-extract-plugin
export default {"container":"style_container__axHkK","logo":"style_logo__7SSub"};